import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { IChatbotGetConvData, IChatbotactivity } from 'src/app/Services/chatbot-service/chatbot.interface';
import { ChatbotService } from 'src/app/Services/chatbot-service/chatbot.service';

@Component({
	selector: 'app-chat-bot-dialog',
	templateUrl: './chat-bot-dialog.component.html',
	styleUrls: ['./chat-bot-dialog.component.scss'],
})
export class ChatBotDialogComponent implements OnInit {
	message = new FormControl('');
	form: FormGroup;
	data: IChatbotGetConvData;
	data$: Observable<IChatbotGetConvData>;
	isTyping$: Observable<boolean>;
	typingActivity: IChatbotactivity;

	constructor(private chatbotService: ChatbotService) {
		this.data$ = this.chatbotService.conData$;
		this.typingActivity = {
			type: 'typing',
			id: '',
			timestamp: '',
			serviceUrl: '',
			channelId: '',
			from: {
				id: '550535748',
				name: 'quoteUser',
			},
			conversation: undefined,
			text: 'typing',
			suggestedActions: undefined,
			attachments: [],
			links: [] as [],
			extenders: undefined,
			embedded: undefined,
			validationDetails: undefined,
			messages: undefined,
			applicationBuildVersion: '',
		};
	}

	ngOnInit(): void {
		this.form = new FormGroup({}, null, null);
		setTimeout(() => {
			console.log('ChatBot ngOnInit focus', document.getElementById('end-of-conversation-container'));
			document.getElementById('end-of-conversation-container') &&
				document.getElementById('end-of-conversation-container').scrollIntoView({
					behavior: 'smooth',
					block: 'end',
					inline: 'nearest',
				});
		}, 200);
		this.isTyping$ = this.chatbotService.isTyping$;
		this.isTyping$.subscribe();
	}

	hideButtonClick() {
		this.chatbotService.showDialog(false);
	}

	sendMessageClick() {
		this.chatbotService.sendMessage(this.message.value);
		this.message.setValue('');
	}
}
